import { useUserContext } from '../../../../Contexts/UserConfig'
import * as React from 'react'
import { useState } from 'react'
import { Box } from '@mui/material'
import { Light } from 'react-syntax-highlighter'
import { darkMode } from '../../../../Functions/GetColourPalette'
import { nnfx, nnfxDark } from 'react-syntax-highlighter/dist/esm/styles/hljs'
import { explanationText } from './SharedFns'

function CodeBlock({ file }: { file: any }) {
  const { loginConfig } = useUserContext()
  const [explanation, setExplanation] = useState('')
  return (
    <Box sx={{ my: -2 }}>
      <Light
        language="oxygene"
        style={darkMode(loginConfig) ? nnfxDark : nnfx}
      >
        {explanationText(file, explanation, setExplanation)}
      </Light>
    </Box>
  )
}

export default CodeBlock
